// extracted by mini-css-extract-plugin
export default {"root":"eLcz2QBnR4cka5nJHIWw","avatar":"rFIWBvMm6_ZADUQyyAf0","name":"q98wFbzKKxuK6jpFk198","link":"_8bSUwtqW9MXOu5AwkEkw"};